import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const navItems = [
  { id: 'sello', label: 'Nuestro sello' },
  { id: 'lineas', label: 'Líneas de negocio' },
  { id: 'como-trabajamos', label: 'Cómo trabajamos' },
  { id: 'natacha', label: 'Sobre Natacha' },
  { id: 'contacto', label: 'Contacto' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="nav-header">
      <div className="flex items-center justify-between w-full px-4">
        {/* Logo */}
        <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
          <img src="/Nutrete_hor_der_BORDE.png" alt="Nútrete" width="200" height="56" loading="eager" decoding="async" className="h-[3.5rem] w-auto" />
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <button key={item.id} onClick={() => scrollToSection(item.id)} className="nav-link">
              {item.label}
            </button>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-full hover:bg-black/5 transition-all"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 mt-2 mx-4 bg-white border border-black/10 rounded-2xl shadow-lg overflow-hidden">
          <div className="flex flex-col p-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="nav-link text-left w-full py-3"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
